<template>
  <section class="custom-specs">
    <div v-for="(option, index) in customMenus" :key="index">
      <!--
        1 = text input 
        4 = image
        8 = textarea
        17 = backgroundcolor         
        19 = phone number         
      -->

      <section
        v-if="option.fieldtype === 1 || option.fieldtype === 19"
        class="spec"
      >
        <label>{{ option.description }}</label>
        <div>
          <span class="prefix" v-if="option.prefix">{{ option.prefix }}</span>
          <input
            type="text"
            @input="setCustomField(option.ids, $event.target.value)"
            v-model="customSpecs.fieldData[option.ids[0]]"
            :placeholder="option.placeholder"
          /><span class="postfix" v-if="option.postfix">{{
            option.postfix
          }}</span>
        </div>
      </section>

      <section v-else-if="option.fieldtype === 17" class="spec">
        <colors-menu
          :options="{
            ...colors,
            property: option.ids,
            title: option.description
          }"
          @set-color="setColor"
        ></colors-menu>
        <!--  :active="customSpecs.fieldData[option.id]" -->
      </section>

      <section v-else-if="option.fieldtype === 8" class="spec">
        <label>{{ option.description }}</label>
        <textarea
          @input="setCustomField(option.ids, $event.target.value)"
          v-model="customSpecs.fieldData[option.ids[0]]"
        ></textarea>
      </section>

      <!--       <section
        v-if="option.fieldtype === 3 && option.fieldname === 'colorMenu'"
      >
        <label>{{ option.description }}</label>
      </section> -->

      <section v-else-if="option.fieldtype === 4" class="spec upload-spec">
        <label>{{ option.description }}</label>
        <div class="button-holder">
          <button class="pill-button" @click="addImage(option.ids)">
            Afbeelding toevoegen
          </button>
          <button
            class="pill-button secondary"
            v-if="hasImage(option.ids)"
            @click="removeImage(option.ids)"
          >
            Afbeelding verwijderen
          </button>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
import CustomImageUpload from '@/dialogs/CustomImageUpload.vue'
import ColorsMenu from '../../../../components/ui/ColorsMenu.vue'
//import { Photoshop } from 'vue-color'

export default {
  components: { ColorsMenu },
  props: ['customSpecs'],
  data() {
    return {
      prevTimeOut: null,
      colors: {
        title: '',
        values: {
          zwart: {
            name: '0 0 0 1',
            color: '#000000 '
          },
          blauw: {
            name: '0.95 0.27 0 0',
            color: '#038bd3 '
          },
          geel: {
            name: '0.01 0.13 0.96 0',
            color: '#ffd800 '
          },
          groen: {
            name: '1 0 1 0',
            color: '#009640'
          },
          rood: {
            name: '0 0.93 0.73 0',
            color: '#e40528'
          },
          wit: {
            name: '0 0 0 0',
            color: '#ffffff'
          }
        }
      }
      //customMenus: []
    }
  },
  computed: {
    customMenus() {
      const customMenus = {}
      const optionsArr = []
      this.customSpecs.options.forEach((option) => {
        if (option.fieldtype === 7) {
          // is hiddenField, no menu needed
          return
        }
        if (optionsArr.indexOf(option.description) < 0) {
          optionsArr.push(option.description)
          customMenus[option.description] = {
            ids: [option.id],
            fieldtype: option.fieldtype,
            description: option.description,
            placeholder: option.placeholder,
            postfix: option.postfix,
            prefix: option.prefix
          }
        } else {
          customMenus[option.description].ids.push(option.id)
        }
      })

      return customMenus
    }
  },
  methods: {
    setColor(val, cmyk, ids, val3) {
      this.$emit('set-custom-field', [ids, 'cmyk ' + cmyk])
    },
    setCustomField(ids, val) {
      if (this.prevTimeOut) {
        clearTimeout(this.prevTimeOut)
      }

      this.prevTimeOut = setTimeout(() => {
        this.$emit('set-custom-field', [ids, val])
      }, 1000)
    },
    hasImage(ids) {
      return ids.some((id) => !!this.customSpecs.fieldData[id])
    },
    removeImage(ids) {
      this.$emit('set-custom-field', [ids, ''])
    },
    addImage(fieldId) {
      this.$modal.show(
        CustomImageUpload,
        {
          title: 'Afbeelding toevoegen',
          fieldId: fieldId,
          callback: (ids, val) => {
            this.$emit('set-custom-field', [ids, val])
          }
        },
        {
          width: 380,
          height: 'auto',
          //maxWidth: 940,
          adaptive: true,
          scrollable: true
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
textarea {
  border-radius: 10px;
  width: 100%;
  height: 100px;
  margin-bottom: 15px;
  padding: 10px;
}

.spec {
  margin-bottom: 10px;

  div {
    display: flex;
    align-items: center;

    .postfix {
      padding-left: 5px;
    }

    .prefix {
      padding-right: 5px;
    }
  }
}

input[type='text'] {
  background: white;
  border-radius: 17px;
  height: 34px;
  padding: 0 10px;
  border: none;
  width: 100%;
}

.custom-specs {
  padding-top: 6px;
  label {
    margin-bottom: 10px;
    display: block;
    float: none;
  }
}

.upload-button {
  background-color: var(--sub-color);
  color: white;
  border-radius: 30px;
  font-size: 11px;
  font-weight: 400;
  border: none;
  padding: 5px 14px;
  transition: 0.3s background-color, 0.3s box-shadow;
  display: block;
  clear: both;

  &:hover {
    box-shadow: rgba(0, 0, 0, 0.5) 0 0 7px 0;
    background-color: var(--sub-color);
  }
}

.upload-spec {
  margin-bottom: 15px;
}

.button-holder {
  display: block;
  clear: both;

  .secondary {
    margin-left: 5px;
  }
}

/* .upload-spec {
  label {
    float: none;
    display: inline-block;
  }
  .button-holder {
  }
} */
</style>
